//const WP_URL = '/blog/wp-json/wp/v2';
const WP_URL = 'https://localhost/blog/wp-json/wp/v2';

export const wpService = {
    getPosts: async (lang = 'en', perPage = 10, page = 1) => {
        try {
            const response = await fetch(`${WP_URL}/posts?_embed&per_page=${perPage}&page=${page}`);
            if (!response.ok) throw new Error('Failed to fetch posts');
            const posts = await response.json();
            return posts.map(post => ({
                id: post.id,
                title: post.title.rendered,
                excerpt: post.excerpt.rendered,
                content: post.content.rendered,
                slug: post.slug,
                date: post.date,
                featuredImage: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || null,
                author: post._embedded?.['author']?.[0]?.name || 'Admin',
            }));
        } catch (error) {
            console.error('Error fetching WordPress posts:', error);
            return [];
        }
    },

    getPostBySlug: async (slug) => {
        try {
            const response = await fetch(`${WP_URL}/posts?slug=${slug}&_embed`);
            if (!response.ok) throw new Error('Failed to fetch post');
            const posts = await response.json();
            if (posts.length === 0) return null;
            const post = posts[0];
            return {
                id: post.id,
                title: post.title.rendered,
                content: post.content.rendered,
                slug: post.slug,
                date: post.date,
                featuredImage: post._embedded?.['wp:featuredmedia']?.[0]?.source_url || null,
                author: post._embedded?.['author']?.[0]?.name || 'Admin',
            };
        } catch (error) {
            console.error('Error fetching WordPress post:', error);
            return null;
        }
    }
};
